<template>
<div>
    <div class="row justify-content-center">
       <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>Committee</span>
                </div>
            </div>
     
    </div>

    <div class="row" style="padding-left: 15px; padding-right: 15px;">
      <div class="col-6 offset-3">
        <div class="container form-background">
           <div class="row">
              <div
                class=" col-12 text-left form-title"
              >
                <span
                  class="row-table-font-margins"
                  
                  >{{formTitle}} for building {{ buildingName }}</span
                >
              </div>
            </div>
          
          <div class="row">
            <div class="col-md-6">
              <label>Name: *</label>
              <input type="text" placeholder="Name" class="form-control" v-model="name" />
                        <div v-if="submitted && !name" class="invalid-feedback d-block">Name is required</div>
            </div>
            <div class="col-md-6">
              <label>Surname: *</label>
              <input type="text" placeholder="Surname" class="form-control" v-model="surname" />
                    <div v-if="submitted && !surname" class="invalid-feedback d-block">Surname is required</div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Phone Number:</label>
              <input type="text" placeholder="Phone number" class="form-control" v-model="phoneNumber" />
            </div>
            <div class="col-md-6">
              <label>Email:</label>
              <input type="email" placeholder="Email" class="form-control" v-model="email" />
                </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Position: </label>
              <select class="form-control" v-model="position">
                        <option value="1">President</option>
                        <option value="2">Vice President</option>
                        <option value="3">Secretary</option>
                        <option value="4">Treasurer</option>
                        <option value="5">Member</option>
                    </select>
                    <div v-if="submitted && !position" class="invalid-feedback d-block">Position is required</div>
                </div>
            
          </div>

          

          <!-- <div v-if="!isPartOfComplex"
            class="form-group"
            style="padding-left: 15px; padding-right: 15px;"
          >
            <strong>Is Complex: </strong>
            <input
              type="checkbox"
              v-model="building.isComplex"
              class="form-check-input"
            />
          </div> -->

        

          <input type="hidden" name="user_id" value="user_id" />
          <section id="complexes" style="display: none;"></section>
        </div>
         <div class="text-right">
          <button type="submit" @click.prevent="saveCommittee()" class="btn btn-submit" style="margin: 15px;">
            Submit
          </button>
          <button @click="cancel()" class="btn btn-cancel">Cancel</button>
        </div>
      </div>
     
    </div>
  </div>


    
</template>

<script>
import { mapState } from "vuex";
    import { redirectToBuildingList } from "@/_helpers/list-redirect";
    export default {
        data: function () {
            return {
                name:'',
                surname:'',
                phoneNumber:'',
                email:'',
                position:1,
                id:0,
                submitted: false,
                formTitle:'Add new committee member',
                buildingId:0,
                submitButtonText:'Submit',
               // buildingName:''
            }
        },
        mounted() {
            if (redirectToBuildingList(this, "committees")) return;
           // this.buildingName = this.$route.params.buildingName;
            if(this.$route.params.id)
            {
                this.formTitle = 'Update committee member';
                this.submitButtonText = 'Update'
                this.buildingId = this.$route.params.buildingId;
                this.id = this.$route.params.id
                this.getCommittee()
            }
            else
            {
                this.buildingId = this.$route.params.buildingId;
              
            }
              
		},
        methods: {
            getCommittee: function(){
                this.$http.get('/committees/'+this.id).then((response)=>{
                    this.buildingId = response.data.buildingId,
                   // this.buildingName = response.data.building.name,
                    this.name = response.data.name,
                    this.surname= response.data.surname,
                    this.email = response.data.email,
                    this.position = response.data.position,
                    this.phoneNumber = response.data.phoneNumber
                });
            },
            cancel(){
                this.$router.push({name:'committees',params:{buildingId: this.buildingId}})
            },
            saveCommittee: function(){
                var canSubmit = this.name && this.surname && this.position
                if (this.id)
                {
                    this.submitted = true;
                    if(canSubmit)
                        this.$http.put('/committees/'+this.id, {
                                id: this.id,
                                name: this.name,
                                surname: this.surname,
                                email:this.email,
                                position:this.position,
                                phoneNumber:this.phoneNumber,
                                buildingId:this.buildingId
                            
                            }).then(() => {
                            this.$router.push({name:'committees',params:{buildingId: this.buildingId}})
                            }, () => {
                                alert('error')
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                            })
                }
                else{
                    this.submitted = true;
                    if(canSubmit)
                        this.$http.post('/committees', {
                                name: this.name,
                                surname: this.surname,
                                email:this.email,
                                position:this.position,
                                phoneNumber:this.phoneNumber,
                                 buildingId:this.buildingId
                            
                            }).then(() => {
                            this.$router.push({name:'committees',params:{buildingId: this.buildingId}})
                            }, () => {
                                alert('error')
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                            })
                        }
            },
            
		},
		computed :{
      ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
		}
        // Our Javascript logic
    }
</script>
